import { selectStyle } from "Redux/appSlice";
import { useAppSelector } from "Redux/hooks";

type Props = {
  id?: string;
  onClick?: () => void;
  label?: string;
  children?: React.ReactNode;
};

export default function AlternativeButton({
  id,
  onClick,
  label = "",
  children = "",
}: Props) {
  const { color4 } = useAppSelector(selectStyle);

  // TODO: use className directly in button element and use colors with tailwind
  const button_element = {
    className:
      "w-fit px-12 py-1 rounded-full font-bold bg-transparent border border-solid transition-colors duration-150",
    styles: {
      color: color4,
      borderColor: color4,
    },
  };
  const content = children !== "" ? children : label;
  return (
    <button
      className={button_element.className}
      style={button_element.styles}
      onClick={onClick}
      id={id}
    >
      {content}
    </button>
  );
}
